import type { AnyShippingMethod, CheckoutV2Configuration } from "@jti/commerce";
import type { AddressInStoreDeliveryFieldValue } from "@jti/commerce-types";
import type { Translate } from "@jti/ui";

import type { FormFieldConfig } from "@checkout-v2/formFields/types/FormFieldConfig.types";
import type { FormFieldFactory } from "@checkout-v2/formFields/types/FormFieldFactory.types";

export type AddressInStoreDeliveryFieldConfig = FormFieldConfig<
  "addressInStoreDelivery",
  {
    shippingMethods: AnyShippingMethod[];
  }
>;

export const addressInStoreDeliveryFieldFactory: FormFieldFactory<
  "addressInStoreDelivery",
  AddressInStoreDeliveryFieldValue,
  [CheckoutV2Configuration, Translate],
  [],
  AddressInStoreDeliveryFieldConfig
> = {
  getDerivedConfig: (checkoutConfiguration, translate) => {
    return {
      name: "addressInStoreDelivery",
      shippingMethods: checkoutConfiguration.shippingMethods,
      registerOptions: {
        required: translate("cart.checkout.delivery.in_store.address_validation"),
      },
    };
  },
  getDefaultValue: () => {
    return null;
  },
};
